// extracted by mini-css-extract-plugin
export var announcementBar = "sliderbanner-modal-module--announcementBar--e3447";
export var slideItemContent = "sliderbanner-modal-module--slide-item-content--be9dc";
export var swiperSlideItem = "sliderbanner-modal-module--swiper-slide-item--ab4c0";